import { type JSX } from "react";
import TigerDataLogo from "assets/logos/tigerdata-logo.svg?react";
import { Box, Flex } from "@chakra-ui/react";
import { BasicCard } from "components/container/BasicCard";
import { history } from "utils/history";
import { Outlet } from "@tanstack/react-router";
import { CenteredBackgroundLayout } from "./CenteredBackgroundLayout";

export const SuccessLayout = ({
  children,
}: {
  children?: JSX.Element | JSX.Element[];
}) => {
  const { location } = history;

  // This hack exists because moving RegisterComplete to a new layout breaks
  // far too many things.
  if (location?.pathname === "/verify") {
    return (
      <Flex alignItems="center" justifyContent="center" h="100vh">
        {children}
      </Flex>
    );
  }

  return (
    <CenteredBackgroundLayout>
      <Box
        as={TigerDataLogo}
        mb="14"
        width="209px"
        height="12"
        color="fg.default"
      />
      <BasicCard minW="400px">
        <Outlet />
      </BasicCard>
    </CenteredBackgroundLayout>
  );
};
